import { combineReducers, configureStore } from '@reduxjs/toolkit';
// import { userApi } from '../services/userService';
import userReducer from './reducers/userSlice';
import filtersReducer from './reducers/filtersSlice';
import paymentsReducer from './reducers/paymentSlice';
import integrationReducer from './reducers/integrationSlice';
import countriesReducer from './reducers/countriesSlice';
import dashboardReducer from './reducers/dashboardSlice';
import cutOffTimeReducer from './reducers/cutOffTimeSlice';

const rootReducer = combineReducers({
  userReducer,
  filtersReducer,
  paymentsReducer,
  integrationReducer,
  countriesReducer,
  dashboardReducer,
  cutOffTimeReducer,
  // [userApi.reducerPath]: userApi.reducer,
});

export const setupStore = () =>
  configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware(),
    //middleware: getDefaultMiddleware => getDefaultMiddleware().concat(userApi.middleware),
  });

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];